import { render, staticRenderFns } from "./shenhe.vue?vue&type=template&id=c6e5149c&scoped=true&"
import script from "./shenhe.vue?vue&type=script&lang=ts&"
export * from "./shenhe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e5149c",
  null
  
)

export default component.exports